import React from 'react';
import { Box } from '@mui/material';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import {
  EMAIL_BODY_COLOR,
  EMAIL_BODY_FONT_FAMILY,
  EMAIL_BODY_FONT_SIZE,
  EMAIL_BODY_LINE_HEIGHT,
  EMAIL_BODY_PADDING,
  EMAIL_WIDTH,
} from './buildEmailPreviewHtml';

const QUILL_MODULES = {
  toolbar: [
    ['bold', 'italic', 'underline'],
    [{ color: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link'],
    ['clean'],
  ],
};

interface Props {
  value: string;
  onChange: (html: string) => void;
}

// Styled to match the sent email's body cell (width, padding, font, line height) so what users type
// looks like what clients receive. Quill's defaults (13px, tight lines, zero paragraph margins) made
// the editor roughly half the height of the real email.
const EmailTemplateEditor: React.FC<Props> = ({ value, onChange }) => (
  <Box
    sx={{
      maxWidth: EMAIL_WIDTH,
      mb: 2,
      '& .ql-container': {
        fontFamily: EMAIL_BODY_FONT_FAMILY,
        fontSize: EMAIL_BODY_FONT_SIZE,
        color: EMAIL_BODY_COLOR,
      },
      '& .ql-editor': {
        padding: EMAIL_BODY_PADDING,
        lineHeight: EMAIL_BODY_LINE_HEIGHT,
        minHeight: 200,
      },
      // Quill zeroes these; email clients use the browser default 1em, so every Enter is a paragraph gap.
      '& .ql-editor p, & .ql-editor ol, & .ql-editor ul': { margin: '1em 0' },
      // Line the placeholder up with the caret, which sits inside the first paragraph's margin.
      '& .ql-editor.ql-blank::before': { left: 40, right: 40, marginTop: '1em' },
    }}
  >
    <ReactQuill
      placeholder="Enter email body here..."
      theme="snow"
      value={value}
      onChange={onChange}
      modules={QUILL_MODULES}
    />
  </Box>
);

export default EmailTemplateEditor;
